<template>
    <div class="game">
        <div class="box">
            <!-- <div class="item">
                <p>{{$t('风格')}}</p>
                <div>
                    <span v-for="(item, index) in tabs1" :key="index" :class="index == tabs1Index ? 'active' : ''"
                        @click="tabs1Index = index">{{ $t(item)}}</span>
                </div>
            </div> -->
            <!-- <div class="item">
                <p>{{$t('想要')}}</p>
                <div><span v-for="(item, index) in tabs2" :key="index" :class="index == tabs2Index ? 'active' : ''"
                        @click="tabs2Index = index">{{ $t(item)}}</span></div>
            </div> -->
            <div class="game_n_content">

                <div class="game_n_title">
                    {{ $t('官方合作数据') }}
                </div>
                <div class="game_n_cell">
                    <div class="game_n_cell_item">
                        <img class="game_n_cell_img" src="/img/qc.png" alt="">
                        <div class="game_n_cell_txt">{{ $t('车费认证') }}</div>
                    </div>
                    <div class="game_n_cell_item">
                        <img class="game_n_cell_img" src="/img/jd.png" alt="">
                        <div class="game_n_cell_txt">{{ $t('酒店认证') }}</div>
                    </div>
                    <div class="game_n_cell_item">
                        <img class="game_n_cell_img" src="/img/rz.png" alt="">
                        <div class="game_n_cell_txt">{{ $t('保密认证') }}</div>
                    </div>
                </div>
            </div>
            <!-- <div class="game_n_addr">{{ $t('在线匹配') }}</div> -->

            <van-button :round="true" @click="toGame()" class="button" style="width: auto;margin-top: 30px;"
                type="primary" color="#f73ba5">
                {{ $t('开启约爱之旅') }}

            </van-button>
            <!-- <button type="button"
                class="van-button van-button--primary van-button--normal van-button--block van-button--round"
                style="color: white; background: linear-gradient(to right, #7030a0 0%, #7030a0 100%); border: 0px;">
                <div class="van-button__content"><span class="van-button__text">开启约爱之旅</span></div>
            </button> -->
        </div>
        <div v-if="isLoading" class="loading"><img src="img/loading.png?t=2" alt=""><span class="loader"></span><span
                class="loader2"></span></div>
    </div>
</template>
<script>

export default {
    data() {
        return {
            gameitem: [],
            lotteryitem: [{}, {}, {}, {}],
            isLoading: false,
            activeKey: 0,
            tabs1: [
                "网红",
                "主播",
                "模特",
                "护士",
                "秘书",
                "人妻",
                "学生",
                "孕妇",
                "母女",
                "萝莉",
                // "御姐"
            ],
            tabs1Index: 0,
            tabs2: [
                "三通",
                "海盗",
                "潮喷",
                "SM"
            ],
            tabs2Index: 0
        };
    },
    methods: {
        getGameItem() {
            this.$http({
                method: 'get',
                url: 'lottery_list'
            }).then(res => {
                this.gameitem = res.data;
            })
        },
        toLottery(key, id) {
            if (!localStorage.getItem('token')) {
                this.$router.push({ path: '/Login' })
            } else {
                this.$router.push({ path: '/Lottery?key=' + key + "&id=" + id })
            }
        },
        toGame() {
            // this.isLoading = true
            // setTimeout(() => {
            //     this.isLoading = false

            //     this.toLottery(this.gameitem[0].key, this.gameitem[0].id)
            // }, 2000)
            if (this.gameitem.length > 0) {

                this.toLottery(this.gameitem[0].key, this.gameitem[0].id)

            } else {
                setTimeout(() => {

                    this.toLottery(this.gameitem[0].key, this.gameitem[0].id)
                }, 300)
            }
        }
    },
    created() {
        this.getGameItem()
    }
}
</script>
<style scoped>
.game {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    background: url(/img/game1.png?t=3) no-repeat top/100% 100%
}

.game .box {
    width: 94%;
    /* background: #ffffffab; */
    border-radius: 1.33333rem;
    /* border: .26667rem solid #ffd5db; */
    margin: 19.66667rem auto;
    padding: .66667rem .33333rem
}

.game .box .item {
    display: flex;
    color: #666;
    font-size: .83333rem
}

.game .box .item p {
    padding: .33333rem 1.66667rem
}

.game .box .item>div {
    flex: 1;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-wrap: wrap
}

.game .box .item>div span {
    padding: .46667rem .8rem;
    border-radius: 3.33333rem
}

.game .box .item>div span.active {
    background: #7030a0ab;
    color: #fff
}

.game .box .van-button--block {
    margin: 30px auto;
    width: 60%
}

.game .loading {
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    right: 0;
    margin: auto;
    background: #fea4a6
}

.game .loading img {
    position: absolute;
    width: 150%;
    left: 0;
    top: 0;
    height: 100%;
    animation: moves-7cdca153 5s
}

@keyframes moves-7cdca153 {
    0% {
        transform: translateY(20%)
    }

    to {
        transform: translate(-20%)
    }
}

.game .loading .loader {
    position: absolute;
    z-index: 999;
    bottom: 5rem;
    left: 0;
    right: 0;
    margin: auto;
    opacity: .5
}

.game .loading .loader2 {
    transform: rotate(45deg);
    perspective: 33.33333rem;
    border-radius: 50%;
    width: 8.26667rem;
    height: 8.26667rem;
    color: #fff;
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto
}

.game .loading .loader2:after,
.game .loading .loader2:before {
    content: "";
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    width: inherit;
    height: inherit;
    border-radius: 50%;
    transform: rotateX(70deg);
    animation: spin-7cdca153 1s linear infinite
}

.game .loading .loader2:after {
    color: #fff;
    transform: rotateY(70deg);
    animation-delay: .4s
}

@keyframes rotate-7cdca153 {
    0% {
        transform: translate(-50%, -50%) rotate(0deg)
    }

    to {
        transform: translate(-50%, -50%) rotate(1turn)
    }
}

@keyframes rotateccw-7cdca153 {
    0% {
        transform: translate(-50%, -50%) rotate(0deg)
    }

    to {
        transform: translate(-50%, -50%) rotate(-1turn)
    }
}

@keyframes spin-7cdca153 {

    0%,
    to {
        box-shadow: .2em 0 0 0 currentcolor
    }

    12% {
        box-shadow: .2em .2em 0 0 currentcolor
    }

    25% {
        box-shadow: 0 .2em 0 0 currentcolor
    }

    37% {
        box-shadow: -.2em .2em 0 0 currentcolor
    }

    50% {
        box-shadow: -.2em 0 0 0 currentcolor
    }

    62% {
        box-shadow: -.2em -.2em 0 0 currentcolor
    }

    75% {
        box-shadow: 0 -.2em 0 0 currentcolor
    }

    87% {
        box-shadow: .2em -.2em 0 0 currentcolor
    }
}

.game .loader {
    font-size: 1.6rem;
    color: transparent;
    overflow: hidden;
    display: inline-block;
    font-family: Arial, Helvetica, sans-serif;
    text-shadow: 0 0 #fff, 80em 0 #fff;
    animation: marquee-7cdca153 2s ease infinite
}

.game .loader:before {
    content: ""
}

@keyframes marquee-7cdca153 {
    to {
        text-shadow: -18.33333rem 0 #fff, 0 0 #fff
    }
}

.game_n_content {

    background: #ffffffab;
    border-radius: 20px;
    padding: 30px;
    margin: 20px 0;
}

.game_n_title {
    background: #f73ba5;
    border-radius: 50px;
    display: inline-block;
    padding: 12px 20px;
    color: #ffffff;
    font-size: 24px;
    margin: auto;
}

.game_n_cell {
    display: flex;

}

.game_n_cell_item {

    flex: 1;
    margin: 20px;
    padding: 20px 10px;
}

.game_n_cell_img {
    /* width: 80px; */
    height: 60px;
}

.game_n_cell_txt {
    margin-top: 10px;
    font-size: 24px;
}

.game_n_addr {
    background: #ffffffab;

    width: 90%;
    margin: auto;
    border-radius: 20px;
    height: 80px;
    line-height: 80px;
    margin-top: 30px;
}
</style>